export default __webpack_public_path__ + "static/media/bedroom4.4950bc9c.mp3";